<template>
  <b-card>
    <b-button
      class="mb-1"
      variant="primary"
      to="/create-announcement"
    >
      Add Announcement
    </b-button>

    <base-overlay :show="fetching">
      <b-table
        :items="list"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(actions)="row">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="`/edit-announcement/${row.item.id}`">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="confirmDelete(row.item)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </base-overlay>

    <!-- Delete Confirmation Modal -->
    <b-modal
      v-model="showDeleteModal"
      title="Confirm Deletion"
      @hide="selectedItemToDelete = null"
    >
      <p>Are you sure you want to delete this announcement?</p>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="showDeleteModal = false"
        >
          Cancel
        </b-button>
        <b-button
          :disabled="deleting"
          variant="danger"
          @click="deleteAnnouncement"
        >
          <b-spinner
            v-if="deleting"
            small
          />
          Delete
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BTable, BCard, BButton, BModal, BSpinner, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import store from '../store'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BTable,
    BCard,
    BSpinner,
    BButton,
    BModal,
    BDropdown,
    BDropdownItem,
    FeatherIcon,
  },
  setup(_, ctx) {
    useRegisterStoreModule('announcement', store)

    const fetching = ref(false)
    const list = ref([])
    const showDeleteModal = ref(false)
    const selectedItemToDelete = ref(null)

    const tableColumns = [
      { label: 'ID', key: 'id' },
      { label: 'Name AR', key: 'ar' },
      { label: 'Name EN', key: 'en' },
      { label: 'Background Color', key: 'backgroundColor' },
      { label: 'Text Color', key: 'textColor' },
      {
        label: 'Enabled',
        key: 'enabled',
        formatter: val => (val ? 'Yes' : 'No'),
      },
      {
        label: 'Zone',
        key: 'zone',
        formatter: val => {
          if (val) {
            return val.split('::')[1]
          }
          return '-'
        },
      },
      { key: 'actions', label: 'Actions' },
    ]

    const fetch = async () => {
      fetching.value = true
      const res = await ctx.root.$store.dispatch(
        'announcement/getAnnouncemets',
      )
      const { announcements } = res.data.data
      list.value = announcements
        .filter(anct => anct.announcement)
        .map(anct => ({ ...anct, ...anct.announcement }))
      fetching.value = false
    }

    const confirmDelete = item => {
      selectedItemToDelete.value = item
      showDeleteModal.value = true
    }

    const deleting = ref(false)
    const deleteAnnouncement = async () => {
      try {
        deleting.value = true
        await axiosIns.delete(`/announcement/${selectedItemToDelete.value.id}`)
        showDeleteModal.value = false
        selectedItemToDelete.value = null
        fetch()
      } catch (e) {
        console.error('Failed to delete announcement:', e)
      } finally {
        deleting.value = false
      }
    }

    fetch()

    return {
      fetching,
      deleting,
      tableColumns,
      list,
      showDeleteModal,
      selectedItemToDelete,
      confirmDelete,
      deleteAnnouncement,
    }
  },
}
</script>
